import React from 'react';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { Form, Row, Col } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import BaseService from 'services/BaseService';
import LocationService from 'services/LocationService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class BasicDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        this.setState({
            isLoading: false
        });
    }

    async save() {
        const { subAgency, setIsBusy, setIsChanged, history } = this.props;
        setIsBusy(true);
        this.setState({ isLoading: true });
        const { slug } = await BaseService.callAPI('sub-agency/save-basic-details', subAgency);
        setIsBusy(false);
        setIsChanged(false);
        this.setState({ isLoading: false });
        history.replace(`/sub-agency/${slug}`);
        BootboxHelper.alert('Changes saved');
    }

    updateFields(values) {
        const subAgency = { ...this.props.subAgency };

        for (var fieldName in values) {
            const value = values[fieldName];
            subAgency[fieldName] = value;
            switch (fieldName) {
                case 'countryID':
                    subAgency.country = this.props.countries.find(c => c.id == value);
                    break;
                case 'bankCountryID':
                    subAgency.bankCountry = this.props.countries.find(c => c.id == value);
                    break;
            }
        }
        this.props.onUpdate(subAgency);
        this.props.setIsChanged(true, () => this.save());
    }

    render() {
        const { subAgency, isEditMode, countries, geos } = this.props;
        const { isLoading } = this.state;
        if (isLoading) {
            return (<Loader fullPage />);
        }
        return (<>

            <h2>Basic agency details</h2>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        {isEditMode ?
                            <input
                                type="text"
                                className="form-control"
                                value={subAgency.name || ''}
                                onChange={e => this.updateFields({ name: e.target.value })}
                            /> :
                            <p>{subAgency.name || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Country</Form.Label>
                        {isEditMode ?
                            <Select
                                isClearable={false}
                                options={countries}
                                value={subAgency.country}
                                getOptionValue={c => c.id}
                                getOptionLabel={c => c.name}
                                onChange={country => this.updateFields({ countryID: country.id })}
                            /> :
                            <p>{(subAgency.country ? subAgency.country.name : '') || <>—</>}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Form.Group className="mb-3">
                <Form.Label>Internal notes (Visible to Go Courses only)</Form.Label>
                {isEditMode ?
                    <ExpandingTextArea
                        className="form-control"
                        value={subAgency.internalNotes || ''}
                        onChange={e => this.updateFields({ internalNotes: e.target.value })}
                        rows={3}
                    /> :
                    <p>{subAgency.internalNotes || '—'}</p>
                }
            </Form.Group>

            {this.renderFinancials()}

        </>);
    }

    renderFinancials() {
        const { isEditMode, countries, subAgency } = this.props;

        return (<>

            <h2>Financial details</h2>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Name on bank account</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={subAgency.nameOnBankAccount || ''}
                                onChange={e => this.updateFields({ nameOnBankAccount: e.target.value })}
                            /> :
                            <p>{subAgency.nameOnBankAccount}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Company name</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={subAgency.companyName || ''}
                                onChange={e => this.updateFields({ companyName: e.target.value })}
                            /> :
                            <p>{subAgency.companyName || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Bank address</Form.Label>
                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                value={subAgency.bankAddress || ''}
                                onChange={e => this.updateFields({ bankAddress: e.target.value })}
                                rows={4}
                            /> :
                            <p className="pre">{subAgency.bankAddress}</p>
                        }
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Bank country</Form.Label>
                        {isEditMode ?
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                isClearable={false}
                                options={countries}
                                value={subAgency.bankCountry}
                                getOptionValue={c => c.id}
                                getOptionLabel={c => c.name}
                                onChange={country => this.updateFields({ bankCountryID: country.id })}
                            /> :
                            <p className="pre">{subAgency.bankCountry ? subAgency.bankCountry.name : ''}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Company address</Form.Label>
                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                value={subAgency.address || ''}
                                onChange={e => this.updateFields({ address: e.target.value })}
                                rows={4}
                            /> :
                            <p className="pre">{subAgency.address}</p>
                        }
                    </Form.Group>

                    <Form.Group className="">
                        <Form.Label>Payment type</Form.Label>
                        <select
                            className="form-control"
                            value={subAgency.paymentType || ''}
                            onChange={e => this.updateFields({ paymentType: e.target.value })}
                        >
                            <option value="">(Please select)</option>
                            <option value="Euro">Euro</option>
                            <option value="International">International</option>
                            <option value="Faster">Faster</option>
                            <option value="BACS">BACS</option>
                            <option value="USD">USD</option>
                        </select>
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>IBAN</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={subAgency.iban || ''}
                                onChange={e => this.updateFields({ iban: e.target.value })}
                            /> :
                            <p>{subAgency.iban}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>SWIFT / BIC</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={subAgency.swiftbic || ''}
                                onChange={e => this.updateFields({ swiftbic: e.target.value })}
                            /> :
                            <p>{subAgency.swiftbic}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group>
                        <Form.Label>Sort code</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={subAgency.sortCode || ''}
                                onChange={e => this.updateFields({ sortCode: e.target.value })}
                            /> :
                            <p>{subAgency.sortCode}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group>
                        <Form.Label>Account number</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={subAgency.accountNumber || ''}
                                onChange={e => this.updateFields({ accountNumber: e.target.value })}
                            /> :
                            <p>{subAgency.accountNumber}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

        </>);
    }
}

export default BasicDetails;